module.exports = __webpack_public_path__ + "img/fixed_stainless_steel.50e13c00.svg";